import script from "./examination-status.vue?vue&type=script&setup=true&lang=ts"
export * from "./examination-status.vue?vue&type=script&setup=true&lang=ts"

import "./examination-status.vue?vue&type=style&index=0&id=8a20dcd8&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a20dcd8"]])

export default __exports__